var mobile: boolean = false;

export default function(state = mobile, action) {
  switch (action.type) {
    case "MobileUser":
      mobile = true;
      break;
    case "DesktopUser":
      mobile = false;
      break;
    default:
  }

  return mobile;
}



// WEBPACK FOOTER //
// ./src/reducers/mobile-reducer.js